import React, { Component } from "react";
import { sendEnquiry } from "../service/userwsao";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

class Contact extends Component {
  // initialize form
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  // handle change of form values bound to state
  handleChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  }

  // call ws when submitted
  handleSubmit(event) {
    event.preventDefault();

    var data = new FormData(event.target);

    // extract ws data from form
    var payload = {
      user: {
        name: data.get("contact-name"),
        email: data.get("contact-email"),
        phone: data.get("contact-phone"),
      },
      message: data.get("contact-message"),
      subject: data.get("contact-subject"),
    };

    var errors = [];
    // validate user input
    if (!payload.user.name) {
      errors.push("Don't you have a name?! :O");
    }

    if (!payload.user.email) {
      errors.push("You forgot your email!");
    }

    if (!payload.subject) {
      errors.push("You forgot the subject!");
    }

    if (!payload.message) {
      errors.push("You gotta put WORDS in your enquiry homie!");
    }

    // TODO CAPTCHA ERRORS
    if (false) {
      errors.push("You haven't passed the captcha test!");
    }

    if (errors.length > 0) {
      errors.forEach((error) => {
        toast.error(error);
      });

      return;
    }

    // no errors, speak to api
    sendEnquiry(payload, (err, res) => {
      if (err) {
        toast.error("An error occured while sending! :\\");
        toast.error("Tweet me @deztructicus and I'll fix it! ^__^");
      } else {
        // disable submit button
        this.setState({
          submittable: true,
        });

        // show welcome message
        toast.success("Your message has successfully been received!");
      }
    });
  }

  render() {
    return (
      <div>
        <section id="contact">
          <div className="container">
            <div className="row">
              <div className="col-lg-5 col-md-6">
                <h4 className="block-title">
                  Need an answer? Interested in helping out?Get in touch with us here!
                </h4>
                <br />
                <address className="contact-address">
                  {/* <p>Address : PO Box 16122 Collins Street West, Victoria 8007 Australia</p> */}
                  <p>
                    Email : <a href="mailto:info@synthcity.io">info@synthcity.io</a>
                  </p>
                </address>
                <div className="social">
                  <ul className="list-inline">
                    {/* <li className="list-inline-item">
                      <a
                        href="https://www.facebook.com/ZeenoOfficial/"
                        target="_blank"
                        rel="noopener noreferrer"
                        title="facebook page"
                      >
                        <i alt="facebook" className="fa fa-facebook" />
                      </a>
                    </li> */}
                    {/* <li className="list-inline-item">
                      <a
                        href="https://twitter.com/zeenotheinvento"
                        target="_blank"
                        rel="noopener noreferrer"
                        title="twitter profile"
                      >
                        <i className="fa fa-twitter" alt="twitter" />
                      </a>
                    </li> */}
                    {/* <li className="list-inline-item">
                      <a
                        href="https://www.youtube.com/channel/UCz_AcTPMiLi399Ze4PiJ57w"
                        target="_blank"
                        rel="noopener noreferrer"
                        title="youtube channel"
                      >
                        <i className="fa fa-youtube" alt="youtube" />
                      </a>
                    </li> */}
                    {/* <li className="list-inline-item">
                      <a
                        href="https://www.instagram.com/zeenotheinventor/"
                        target="_blank"
                        rel="noopener noreferrer"
                        title="instagram page"
                      >
                        <i className="fa fa-instagram" alt="instagram" />
                      </a>
                    </li> */}
                  </ul>
                </div>{" "}
                {/* END social*/}
              </div>{" "}
              {/* END col-lg-5*/}
              <div className="col-md-6 ml-lg-auto">
                <form onSubmit={this.handleSubmit} className="contact-form" data-toggle="validator">
                  <div className="form-send-callback" />
                  <div className="row">
                    <div className="col-sm-6">
                      <div className="form-group">
                        <input
                          type="text"
                          className="form-control"
                          name="contact-name"
                          placeholder="Name"
                          required
                        />
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="form-group">
                        <input
                          type="email"
                          className="form-control"
                          name="contact-email"
                          placeholder="Email"
                          required
                        />
                      </div>
                    </div>
                  </div>{" "}
                  {/* END row*/}
                  <div className="row">
                    <div className="col-sm-6">
                      <div className="form-group">
                        <input
                          type="number"
                          className="form-control"
                          name="contact-phone"
                          placeholder="Phone"
                        />
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="form-group">
                        <input
                          type="text"
                          className="form-control"
                          name="contact-subject"
                          placeholder="Subject"
                          required
                        />
                      </div>
                    </div>
                  </div>{" "}
                  {/* END row*/}
                  <div className="form-group">
                    <textarea
                      className="form-control"
                      name="contact-message"
                      placeholder="Message"
                      rows={8}
                      required
                      defaultValue={""}
                    />
                  </div>
                  <button className="btn btn-block btn-theme" type="submit">
                    GO!
                  </button>
                </form>
              </div>{" "}
              {/* END col-md-6 col-md-offset-1*/}
            </div>{" "}
            {/* END row*/}
          </div>{" "}
          {/* END container*/}
        </section>{" "}
        {/* END contact*/}
        {/* <div id="location-map" style={{ width: '100%', height: 450 }} /> */}
      </div>
    );
  }
}

export default Contact;



// WEBPACK FOOTER //
// ./src/components/synthcity/landing/Contact.js